// extracted by mini-css-extract-plugin
export var sliderRange = "_pv-2";
export var sliderRoot = "_pv-0";
export var sliderThumb = "_pv-3";
export var sliderTrack = "_pv-1";